import { useState } from 'react'
import { useInfiniteQuery, useQueryClient } from 'react-query'
import { fetchUsers } from 'api/services/user'
import { DEFAULT_PARAMS } from 'enum/infiniteQuery'

export const useUsers = (initialFetchInfo = {}) => {
  const queryClient = useQueryClient()
  const [fetchInfo, setFetchInfo] = useState({
    ...DEFAULT_PARAMS,
    ...initialFetchInfo,
  })

  return {
    ...useInfiniteQuery(
      ['users', fetchInfo],
      ({ pageParam }) => fetchUsers(fetchInfo, pageParam),
      {
        onSuccess: () => {
          queryClient.invalidateQueries('users')
        },
        getNextPageParam: ({current_page, last_page}) => {
          if (current_page < last_page) {
            return { page: current_page + 1 }
          }
  
          return false
        }
      }
    ),
    fetchInfo,
    setFetchInfo,
  }
}
